module.exports = __webpack_public_path__ + "img/coupon_b.7ed10154.svg";